import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

export const useDownloadAdditionalTaxes = () => {
  const res = useMutation(({ clinicId, invoiceId }) =>
    http.get(
      HTTP_ENDPOINTS.customTax.downloadAdditionalTaxesDetails({
        clinicId,
        invoiceId,
      }),
    ),
  );
  return res;
};
